module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"Off-Budget Account":"Счёт не участвует в бюджете"}}')
  delete Component.options._Ctor
}
